// extracted by mini-css-extract-plugin
export default {"metric__container":"style_metric__container__2oP-t","metrcs__main_container":"style_metrcs__main_container__U+FyO","metric_id_col":"style_metric_id_col__raR6-"};